var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"game-container flex justify-center"},[(_vm.isLoaded)?_c('div',{staticClass:"game-box",class:{
      mobile: _vm.$device.mobile,
      desktop: !_vm.$device.mobile,
      horizontal: _vm.getSelectedDirection === 'horizontal',
      vertical: _vm.getSelectedDirection === 'vertical',
    }},[_c('img',{staticClass:"background left",attrs:{"src":require("@assets/img/allgame/background-left.png")}}),_c('img',{staticClass:"background right",attrs:{"src":require("@assets/img/allgame/background-right.png")}}),_c('iframe',{ref:"gameFrame",staticClass:"game-iframe",attrs:{"scrolling":"no","id":"iframe","src":`https://game.x-beta-pr.net/${_vm.getDirection()}/`,"allow":"fullscreen"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }